export const status_filter = [
    { value: 1, name: "Active", type: "checkbox" },
    { value: 2, name: "In-active", type: "checkbox" },
  ];
  export const email_filter = [
    { value: 1, name: "Verified", type: "checkbox" },
    { value: 2, name: "Not-verified", type: "checkbox" },
  ];